import http from '@/http'

export const createUser = async (newUser) => {
  try {
    const response = await http.post(`/users`, newUser)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao criar o usuário', error)
  }
}

export const updateUser = async (codUser, updatedUser) => {
  try {
    const response = await http.put(`/users/${codUser}`, updatedUser)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao atualizar o usuário', error)
  }
}

export const removeUser = async codUser => {
  try {
    const response = await http.delete(`/users/${codUser}`)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao remover o usuário', error)
  }
}

export const listUsers = async () => {
  try {
    const response = await http.get('/users')
    return response.data
  } catch (error) {
    console.log('Houve um erro ao obter os usuários', error)
  }
}

export const getUser = async codUser => {
  try {
    const response = await http.get(`/users/${codUser}`)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao obter o usuário', error)
  }
}

export const sendEmailUser = async (codUser, dataEmail) => {
  try {
    const response = await http.post(`/emails/users/${codUser}/send`, dataEmail)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao Enviar o Email', error)
  }
}

export const listEmailsUser = async tokenUser => {
  try {
    const response = await http.get(`/emails/users/${tokenUser}`)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao Listar os Emails do Usuário', error)
  }
}

export const getStatusEmail = async (tokenUser, idEmailBry) => {
  try {
    const response = await http.get(`/emails/users/${tokenUser}/status/${idEmailBry}`)
    return response.data
  } catch (error) {
    console.log('Houve um erro ao obter o status do Email', error)
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users.service.js